import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'azure-openai',
  version: '1.0.0',
  properties: [
    // ==================================================================
    // CREDENTIALS
    // ==================================================================
    {
      key: 'credentialId',
      label: 'API Credential',
      type: 'credential',
      required: true,
      typeOptions: {
        credentialType: 'azure-openai',
      },
      description: 'Azure OpenAI API credentials (API key and endpoint)',
    },

    // ==================================================================
    // MODEL CONFIGURATION
    // ==================================================================
    {
      key: 'deploymentName',
      label: 'Deployment Name',
      type: 'string',
      required: true,
      default: 'gpt-4',
      description: 'The name of your Azure OpenAI deployment',
    },

    // ==================================================================
    // LLM PARAMETERS
    // ==================================================================
    {
      key: 'temperature',
      label: 'Temperature',
      type: 'number',
      default: 0.7,
      typeOptions: {
        minValue: 0,
        maxValue: 2,
        numberPrecision: 1,
      },
      description: 'Controls randomness (0 = deterministic, 2 = very creative)',
    },
    {
      key: 'maxTokens',
      label: 'Max Tokens',
      type: 'number',
      default: 4096,
      typeOptions: {
        minValue: 1,
        maxValue: 8192,
      },
      description: 'Maximum tokens in the response',
    },
    {
      key: 'topP',
      label: 'Top P',
      type: 'number',
      default: 1,
      typeOptions: {
        minValue: 0,
        maxValue: 1,
        numberPrecision: 2,
      },
      description: 'Nucleus sampling threshold',
    },
    {
      key: 'frequencyPenalty',
      label: 'Frequency Penalty',
      type: 'number',
      default: 0,
      typeOptions: {
        minValue: -2,
        maxValue: 2,
        numberPrecision: 1,
      },
      description: 'Penalize repeated tokens',
    },
    {
      key: 'presencePenalty',
      label: 'Presence Penalty',
      type: 'number',
      default: 0,
      typeOptions: {
        minValue: -2,
        maxValue: 2,
        numberPrecision: 1,
      },
      description: 'Penalize tokens based on presence',
    },
  ],
};

export default schema;
